export default "__VITE_ASSET__Dabp9BHx__"